

















import { Component, Mixins } from 'vue-property-decorator'
import InputWithLabel from '@/components/common/atoms/InputWithLabel.vue'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import LoginMethods from '@/mixins/LoginMethods.vue'

@Component({
  components: {
    InputWithLabel,
    ButtonBase,
  },
})
export default class Login extends Mixins(LoginMethods) {
  private academyCode = ''

  private accountCode = ''

  private password = ''

  private async submitLogin() {
    this.academyLogin(this.academyCode, this.accountCode, this.password)
  }
}
